import { queryOptions } from "@tanstack/react-query"

import type { SceneFilters } from "./domain"
import {
  getAdminOverviewFn,
  getDashboardFn,
  getDownloadsFn,
  getHelpFn,
  getOrdersFn,
  getPublicDataFn,
  getScenesFn,
  getViewerFn,
} from "@/server/functions"

export const serviceQueryKeys = {
  all: ["service-portal-demo"] as const,
  public: () => [...serviceQueryKeys.all, "public"] as const,
  viewer: () => [...serviceQueryKeys.all, "viewer"] as const,
  dashboard: () => [...serviceQueryKeys.all, "dashboard"] as const,
  scenes: (filters: SceneFilters) =>
    [...serviceQueryKeys.all, "scenes", filters] as const,
  orders: () => [...serviceQueryKeys.all, "orders"] as const,
  downloads: () => [...serviceQueryKeys.all, "downloads"] as const,
  help: () => [...serviceQueryKeys.all, "help"] as const,
  admin: () => [...serviceQueryKeys.all, "admin"] as const,
}

export function publicQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.public(),
    queryFn: () => getPublicDataFn(),
    staleTime: 60_000,
  })
}

export function viewerQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.viewer(),
    queryFn: () => getViewerFn(),
    staleTime: 30_000,
  })
}

export function dashboardQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.dashboard(),
    queryFn: () => getDashboardFn(),
    staleTime: 10_000,
  })
}

export function scenesQueryOptions(filters: SceneFilters) {
  return queryOptions({
    queryKey: serviceQueryKeys.scenes(filters),
    queryFn: () => getScenesFn({ data: filters }),
    staleTime: 15_000,
  })
}

export function ordersQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.orders(),
    queryFn: () => getOrdersFn(),
    staleTime: 10_000,
  })
}

export function downloadsQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.downloads(),
    queryFn: () => getDownloadsFn(),
    staleTime: 10_000,
  })
}

export function helpQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.help(),
    queryFn: () => getHelpFn(),
    staleTime: 5 * 60_000,
  })
}

export function adminOverviewQueryOptions() {
  return queryOptions({
    queryKey: serviceQueryKeys.admin(),
    queryFn: () => getAdminOverviewFn(),
    staleTime: 10_000,
  })
}
